import React from "react";

export interface UseDisclosureProps {
    defaultIsOpen?: boolean;
}

export interface UseDisclosureReturn {
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
    onToggle: () => void;
}

export function useDisclosure(props: UseDisclosureProps = {}): UseDisclosureReturn {
    const [isOpen, setIsOpen] = React.useState(props.defaultIsOpen || false);

    const onClose = React.useCallback(() => {
        setIsOpen(false);
    }, []);

    const onOpen = React.useCallback(() => {
        setIsOpen(true);
    }, []);

    const onToggle = React.useCallback(() => {
        const action = isOpen ? onClose : onOpen;
        action();
    }, [isOpen, onOpen, onClose]);

    return {
        isOpen: !!isOpen,
        onOpen,
        onClose,
        onToggle,
    };
}
